import React, { useState } from 'react';
import { IconPlus, IconSearch, IconGrid, IconEdit, IconTrash } from './Icons';
import './Rejoinings.css';

const SAMPLE_REJOINING = {
  id: 1,
  date: '2025-02-09',
  type: 'On Leave',
  employee: 'Majida Admin',
};

export default function Rejoinings() {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const COLUMNS = [
    { key: 'srNo', label: 'Sr.No' },
    { key: 'date', label: 'Date' },
    { key: 'type', label: 'Type' },
    { key: 'employee', label: 'Employee' },
  ];

  const handleExportExcel = () => {
    const header = COLUMNS.map((c) => c.label);
    const rows = [[SAMPLE_REJOINING.id, SAMPLE_REJOINING.date, SAMPLE_REJOINING.type, SAMPLE_REJOINING.employee]];
    const csvLines = [header, ...rows].map((cols) =>
      cols
        .map((v) => {
          const s = v == null ? '' : String(v);
          return s.includes('"') || s.includes(',') || s.includes('\n') ? `"${s.replace(/"/g, '""')}"` : s;
        })
        .join(','),
    );
    const blob = new Blob([csvLines.join('\n')], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'rejoinings-export.csv';
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="rej-page">
      <div className="rej-card">
        <div className="rej-header-row">
          <h1 className="rej-title">Rejoinings</h1>
          <div className="rej-header-actions">
            <button
              type="button"
              className="rej-header-btn rej-header-btn-primary"
              onClick={() => setShowAddModal(true)}
            >
              <IconPlus />
              Add Rejoining
            </button>
          </div>
        </div>

        <div className="rej-filters-row">
          <div className="rej-filters-left">
            <button
              type="button"
              className="rej-layout-toggle"
              aria-label="Layout options"
            >
              <IconGrid />
            </button>
          </div>

          <div className="rej-filters-right">
            <button type="button" className="rej-utility-btn" onClick={handleExportExcel}>
              Excel
            </button>
            <div className="rej-search">
              <input type="text" placeholder="Search" aria-label="Search rejoinings" />
              <span className="rej-search-icon">
                <IconSearch />
              </span>
            </div>
          </div>
        </div>

        <div className="rej-table-wrapper">
          <table className="rej-table">
            <thead>
              <tr>
                {COLUMNS.map((col) => (
                  <th key={col.key}>{col.label}</th>
                ))}
                <th />
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{SAMPLE_REJOINING.id}</td>
                <td>{SAMPLE_REJOINING.date}</td>
                <td>{SAMPLE_REJOINING.type}</td>
                <td>{SAMPLE_REJOINING.employee}</td>
                <td>
                  <div className="rej-row-actions">
                    <button
                      type="button"
                      className="rej-row-icon-btn"
                      onClick={() => setShowEditModal(true)}
                      aria-label="Edit rejoining"
                    >
                      <IconEdit />
                    </button>
                    <button
                      type="button"
                      className="rej-row-icon-btn"
                      onClick={() => setShowDeleteModal(true)}
                      aria-label="Delete rejoining"
                    >
                      <IconTrash />
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="rej-footer-row">
          <div className="rej-footer-left">
            <select
              className="rej-page-size"
              defaultValue="10"
              aria-label="Rows per page"
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
            <span>1-1 / 1</span>
          </div>
          <div className="rej-footer-right">
            <button
              type="button"
              className="rej-page-btn"
              aria-label="Previous page"
            >
              «
            </button>
            <button
              type="button"
              className="rej-page-btn rej-page-btn-active"
              aria-label="Current page"
            >
              1
            </button>
            <button
              type="button"
              className="rej-page-btn"
              aria-label="Next page"
            >
              »
            </button>
          </div>
        </div>
      </div>

      {showAddModal && (
        <div
          className="estimates-modal-backdrop"
          onClick={() => setShowAddModal(false)}
        >
          <div
            className="estimates-modal"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className="estimates-modal-header">
              <h2 className="estimates-modal-title">Add Rejoining</h2>
              <button
                type="button"
                className="estimates-modal-close"
                onClick={() => setShowAddModal(false)}
                aria-label="Close"
              >
                ×
              </button>
            </div>

            <div className="estimates-modal-body">
              <div className="estimates-form-grid">
                <div className="estimates-form-label">User</div>
                <select className="estimates-form-select" defaultValue="">
                  <option value="">Abdulrahman Al Hinai</option>
                </select>

                <div className="estimates-form-label">Type</div>
                <select className="estimates-form-select" defaultValue="">
                  <option value="">On Leave</option>
                </select>

                <div className="estimates-form-label">Date</div>
                <input className="estimates-form-input" placeholder="Date" />
              </div>
            </div>

            <div className="estimates-modal-footer">
              <button
                type="button"
                className="estimates-footer-btn"
                onClick={() => setShowAddModal(false)}
              >
                Close
              </button>
              <button
                type="button"
                className="estimates-footer-btn estimates-footer-btn-primary"
                onClick={() => setShowAddModal(false)}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {showEditModal && (
        <div
          className="estimates-modal-backdrop"
          onClick={() => setShowEditModal(false)}
        >
          <div
            className="estimates-modal"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className="estimates-modal-header">
              <h2 className="estimates-modal-title">Edit Rejoining</h2>
              <button
                type="button"
                className="estimates-modal-close"
                onClick={() => setShowEditModal(false)}
                aria-label="Close"
              >
                ×
              </button>
            </div>

            <div className="estimates-modal-body">
              <div className="estimates-form-grid">
                <div className="estimates-form-label">User</div>
                <select
                  className="estimates-form-select"
                  defaultValue={SAMPLE_REJOINING.employee}
                >
                  <option value={SAMPLE_REJOINING.employee}>
                    {SAMPLE_REJOINING.employee}
                  </option>
                </select>

                <div className="estimates-form-label">Type</div>
                <select
                  className="estimates-form-select"
                  defaultValue={SAMPLE_REJOINING.type}
                >
                  <option value={SAMPLE_REJOINING.type}>
                    {SAMPLE_REJOINING.type}
                  </option>
                </select>

                <div className="estimates-form-label">Date</div>
                <input
                  className="estimates-form-input"
                  defaultValue={SAMPLE_REJOINING.date}
                />
              </div>
            </div>

            <div className="estimates-modal-footer">
              <button
                type="button"
                className="estimates-footer-btn"
                onClick={() => setShowEditModal(false)}
              >
                Close
              </button>
              <button
                type="button"
                className="estimates-footer-btn estimates-footer-btn-primary"
                onClick={() => setShowEditModal(false)}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {showDeleteModal && (
        <div
          className="estimates-modal-backdrop"
          onClick={() => setShowDeleteModal(false)}
        >
          <div
            className="estimates-modal"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className="estimates-modal-header">
              <h2 className="estimates-modal-title">Delete Rejoining?</h2>
              <button
                type="button"
                className="estimates-modal-close"
                onClick={() => setShowDeleteModal(false)}
                aria-label="Close"
              >
                ×
              </button>
            </div>
            <div className="estimates-modal-body">
              <p>Are you sure? You won&apos;t be able to undo this action!</p>
            </div>
            <div className="estimates-modal-footer">
              <button
                type="button"
                className="estimates-footer-btn"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="estimates-footer-btn estimates-footer-btn-primary"
                onClick={() => setShowDeleteModal(false)}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

